(function () {
    'use strict';

    $(document).ready(function () {

        // responsive image enlarging
        $('.popup-trigger').click(function (e) {
            $(this).parent().find('.popup-image-container').fadeIn();
            e.preventDefault();
            return false;
        });

        $('.popup-image-container').click(function () {
            $(this).fadeOut();
        });

        // accordion scroll animation
        $('.subpage .accordion.scroll-animation .collapse').on('shown.bs.collapse', function (e) {
            updateTableSize();
            var positionTop = $(this).parent().offset().top;
            $('html, body').animate({
                scrollTop: positionTop
            }, 500);
            $(window).resize();
        });

        //timeline module
        $('.subpage .timeline').each(function() {
            var $container = $(this);
            $container.find('.element-row').click(function() {
                $(this).find('.content').slideToggle();
                $(this).toggleClass('active');
            });
        });

        //Tooltipster

        // default tooltips
        $('.default-tooltipster').tooltipster({
            maxWidth: 290,
            contentAsHTML: true,
            interactive: true,
            functionPosition: function (instance, helper, position) {
                position.coord.left = helper.geo.origin.offset.left - 20;
                position.coord.top = position.coord.top - 20;
                return position;
            },
        });

        //tables
        updateTableSize();

        $(window).on('resize', updateTableSize);

    });

    function scrollTo(div_id) {
        $('html, body').animate({
            scrollTop: $(div_id).offset().top
        }, 'slow');
        return false;
    }

    function updateTableSize() {

        $('.table-container').each(function () {
            var containerWidth = $(this).width();
            var tableWidth = $('table', this).width();

            if($('table', this).hasClass('freeze-header') && $(window).width() > 768) {
                return
            }
            if ($(this).hasClass('prevent-scrollable')) {
                if(!$(this).parent().hasClass('card-body')) {
                    return;
                }
            }

            if (tableWidth > containerWidth) {
                $(this).addClass('scrollable');
                $(this).mCustomScrollbar({
                    axis: "x",
                    mouseWheel: {
                        enable: true
                    }
                });
            } else {
                $(this).removeClass('scrollable');
                $(this).mCustomScrollbar('destroy');
            }
        });
    }
}(jQuery));